import { type FormEvent, useState } from 'react';
import { requestPasswordReset } from '@/lib/authClient';
import { AuthCard, authButtonClass, authInputClass } from './AuthCard';

/** Request a password-reset email. Always shows the same confirmation regardless
 *  of whether the account exists (no probing). */
export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setSubmitting(true);
    await requestPasswordReset(email).catch(() => {});
    setSubmitting(false);
    setSent(true);
  };

  return (
    <AuthCard>
      {sent ? (
        <p className="text-center text-sm text-content-deemphasized">
          If an account exists for that email, a reset link is on its way. Check your inbox.
        </p>
      ) : (
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <label className="flex flex-col gap-1 text-sm font-medium text-content-text">
            Email
            <input
              type="email"
              autoComplete="email"
              required={true}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className={authInputClass}
            />
          </label>
          <button type="submit" disabled={submitting} className={authButtonClass}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
      <div className="mt-6 text-center text-xs text-content-subtle">
        <a href="/" className="hover:text-secondary-emphasized">
          Back to sign in
        </a>
      </div>
    </AuthCard>
  );
};
